import { useTranslate } from '@growtherapy/i18n';
import { Body } from '@growtherapy/sprout-ui';

export function CoachInteractionsTable({ topics }: { topics: string[] }): JSX.Element {
  const t = useTranslate();

  return (
    <div>
      <Body.Default emphasis>{t('telehealth-core:providerIntersessionSummary.coachInteractions')}</Body.Default>
      {topics.length ? (
        topics.map((topic, index) => (
          <div key={index} className='flex flex-row justify-between py-2 border-b rebrand:border-border-subtle'>
            <Body.Small className='text-neutral-800'>{topic} </Body.Small>
          </div>
        ))
      ) : (
        <Body.Small className='text-neutral-700 rebrand:text-text-muted'>
          {t('telehealth-core:providerIntersessionSummary.encourageCoachUsage')}
        </Body.Small>
      )}
    </div>
  );
}
